export default __webpack_public_path__ + "static/media/TSchedule2.1e34d36c.png";